<template>
  <div id="app">
    <!-- <modal name="modal" /> -->
    <notifications group="foo" position="bottom center" :max="4" />
    <MainLayout>
      <FadeTransition>
        <router-view />
      </FadeTransition>
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import FadeTransition from "@/components/transitions/FadeTransition";

export default {
  components: {
    MainLayout,
    FadeTransition
  }
};
</script>

<style>
/* Customize modal background */
.vm--overlay {
  backdrop-filter: blur(10px);
}

/* Custom side card animation */
.vm-transition--side-card-enter-active,
.vm-transition--side-card-leave-active {
  transition: transform 250ms ease-in-out;
}

.vm-transition--side-card-enter,
.vm-transition--side-card-leave-active {
  transform: translateX(600px);
}
</style>
